import { AppRoutes } from "@/shared/config/router";
import { AppRoutesProps } from "@/shared/types/router";
import { LoginPage } from "@/pages/LoginPage";
import { ProtectedContent } from "@/pages/ProtectedContentPage";
import { PlayerPage } from "@/pages/PlayerPage";
import { CalcPage } from "@/pages/CalculatorPage";
import { MainPage } from "@/pages/MainPage";
import { TermsAndConditionsPage } from "@/pages/TermsAndConditionsPage";

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
    [AppRoutes.MAIN]: {
        path: "main",
        element: <MainPage />,
        authOnly: true,
    },
    [AppRoutes.TermsAndConditions]: {
        path: AppRoutes.TermsAndConditions,
        element: <TermsAndConditionsPage />,
        authOnly: true,
    },
    [AppRoutes.PLAYER]: {
        path: "player",
        element: <PlayerPage />,
        authOnly: true,
    },
    [AppRoutes.LOGIN]: {
        path: "login",
        element: <LoginPage />,
    },
    [AppRoutes.CALCULATOR]: {
        path: "calc",
        element: <CalcPage />,
    },
    [AppRoutes.RAG]: {
        path: "rag",
        element: <ProtectedContent />,
        authOnly: true,
    },
    // last
    [AppRoutes.NOT_FOUND]: {
        path: "*",
        element: <div>404</div>,
    },
};
